import React from "react";
import Icon from "./Icon";
export default function Clock(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M11 20.1667C16.0627 20.1667 20.1667 16.0626 20.1667 11C20.1667 5.93739 16.0627 1.83333 11 1.83333C5.93743 1.83333 1.83337 5.93739 1.83337 11C1.83337 16.0626 5.93743 20.1667 11 20.1667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5V11L14.6667 12.8333"
  }));
}
Clock.displayname = "Clock";
//# sourceMappingURL=Clock.js.map